import constants from "./constants";

const inviteTeamUrl = (id) => `/teams/${id}/invites/new`;
const membersUrl = (id) => `/teams/${id}/members`;
const setupTeamUrl = (id) => `/teams/${id}/setup`;
const campaignsUrl = (id) => `/teams/${id}`;
const signUpUrl = (encodedURI) => {
  if (!encodedURI) return `/signup`;
  return `/signup?r=${encodedURI}`;
};
const createTeamUrl = () => `/teams/new`;

const joinTeamUrl = (id) => `/teams/${id}/joins/intro`;

const feedUrl = (id) => `/teams/${id}/activity`;

const sendThanksUrl = (id, supporter_id) =>
  `/teams/${id}/guide/supporters/${supporter_id}/new_thanks`;

const updateActivityUrl = (id, support_id) =>
  `/teams/${id}/guide/supporters/${support_id}/new_support_message`;

const paymentsUrl = (id) => `/teams/${id}/guide/payments`;

const newBeneficiaryUrl = (id) => `/teams/${id}/guide/beneficiary/new`;
const beneficiaryIntroUrl = (id) => `/teams/${id}/guide/beneficiary/intro`;
const beneficiaryTypeUrl = (id) => `/teams/${id}/guide/beneficiary/type`;
const beneficiaryTransferUrl = (id) => `/teams/${id}/guide/beneficiary/transfer`;
const beneficiarySuccessUrl = (id) => `/teams/${id}/guide/beneficiary/success`;
const beneficiaryChequeUrl = (id) => `/teams/${id}/guide/beneficiary/cheque`;
const occasionUrl = (id) => `/occasions/${id}`;

const storeUrl = ({ id, campaignId = null }) =>
  `${campaignId ? `/teams/${campaignId}` : ""}/stores/${id}`;
const collectionUrl = ({ id, campaignId = null }) =>
  `${campaignId ? `/teams/${campaignId}` : ""}/collections/${id}`;
const brandsUrl = ({ campaignId = null }) => `${campaignId ? `/teams/${campaignId}` : ""}/brands`;
const brandModalUrl = ({ id, locationId }) =>
  locationId
    ? `?${constants.brandParam}=${id}&location_id=${locationId}`
    : `?${constants.brandParam}=${id}`;
const linkModalUrl = ({ id }) => `?${constants.linkParam}=${id}`;
const favoritesUrl = () => `?modal=${constants.favoritesParam}`;
const searchUrl = () => `?modal=${constants.searchParam}`;

const referralsUrl = (id) => `/teams/${id}/referrals`;

const myActivityUrl = "/user/activity";
const cashbackPolicyUrl = "/pages/cashback-policy";
const termsOfUseUrl = "/pages/terms-of-use";
const privacyUrl = "/pages/privacy";
const beneficiaryGuidelinesUrl = "/pages/payment-recipient-guidelines";

const linkedCardsNewUrl = "/user/linked_cards/new";

const createShopUrl = ({ campaignId, linkId, fundraiserId }) => {
  if (!campaignId) return `/user/shop/${linkId}`;
  return `/teams/${campaignId}${fundraiserId ? `/members/${fundraiserId}` : ""}/shop/${linkId}`;
};
const createPurchaseUrl = ({ campaignId, linkId, fundraiserId }) => {
  if (!campaignId) return `/user/purchase/${linkId}`;
  return `/teams/${campaignId}${fundraiserId ? `/members/${fundraiserId}` : ""}/purchase/${linkId}`;
};

const createInStoreUrl = ({ campaignId, linkId, locationId, fundraiserId }) => {
  if (!campaignId) return `/user/in_store/${linkId}?location_id=${locationId}`;
  return `/teams/${campaignId}${
    fundraiserId !== "" ? `/members/${fundraiserId}` : ""
  }/in_store/${linkId}?location_id=${locationId}`;
};

const giftcardWalletUrl = () => {
  return `/user/purchases`;
};

const playbookUrl = "/playbook";

const newTeamsnapPasswordUrl = () => "/teamsnap/passwords/new";

const missingClaimUrl = (token) => `/intents/${token}/missing_claims/start`;
const intentUrl = ({ intentToken, linkId }) => {
  if (!linkId) return `/intents/${intentToken}`;
  return `/intents/${intentToken}?offer_id=${linkId}`;
};

const createIntentUrl = ({ params, campaignId }) =>
  `${campaignId ? `/teams/${campaignId}` : ""}/intents/new${params && `?${params}`}`;
const checkoutThanksUrl = (id) => `/checkout/thanks?t=${id}`;
const checkoutUrl = (token) => `/checkout/${token}`;

const onboardingQuestionUrl = (id) => `/onboarding/questions/${id}`;
const onboardingIntroUrl = "/onboarding/intro";
const onboardingSuccessUrl = "/onboarding/success";
const onboardingBrandsUrl = "/onboarding/brands";
const onboardingGoalUrl = "/onboarding/goal";

const nearbyUrl = ({ campaignId = null, brandId, brandName }) => {
  if (brandId) {
    return `${
      campaignId ? `/teams/${campaignId}` : "user/"
    }/nearby?b=${brandId}&brand=${brandName}`;
  }
  return `${campaignId ? `/teams/${campaignId}` : "user"}/nearby`;
};

const pendingPaymentInfoUrl =
  "http://help.flipgive.com/en/articles/501796-why-do-you-have-a-holding-period-on-funds";

const feesUrl = "http://help.flipgive.com/en/articles/3982846-fees";

const rootUrl = "/";

const eventsUrl = ({ eventId, campaignId }) => `/teams/${campaignId}/events/${eventId}`;

const personalAccountUrl = "/personal-account";

export default {
  inviteTeamUrl,
  setupTeamUrl,
  membersUrl,
  joinTeamUrl,
  feedUrl,
  signUpUrl,
  createTeamUrl,
  sendThanksUrl,
  updateActivityUrl,
  paymentsUrl,
  newBeneficiaryUrl,
  myActivityUrl,
  createShopUrl,
  createPurchaseUrl,
  playbookUrl,
  cashbackPolicyUrl,
  createInStoreUrl,
  collectionUrl,
  occasionUrl,
  storeUrl,
  linkedCardsNewUrl,
  brandsUrl,
  brandModalUrl,
  linkModalUrl,
  favoritesUrl,
  searchUrl,
  campaignsUrl,
  newTeamsnapPasswordUrl,
  missingClaimUrl,
  rootUrl,
  giftcardWalletUrl,
  checkoutThanksUrl,
  checkoutUrl,
  intentUrl,
  onboardingIntroUrl,
  onboardingQuestionUrl,
  onboardingSuccessUrl,
  onboardingBrandsUrl,
  createIntentUrl,
  termsOfUseUrl,
  privacyUrl,
  onboardingGoalUrl,
  referralsUrl,
  nearbyUrl,
  pendingPaymentInfoUrl,
  eventsUrl,
  beneficiaryIntroUrl,
  beneficiaryTypeUrl,
  beneficiaryTransferUrl,
  beneficiarySuccessUrl,
  beneficiaryChequeUrl,
  beneficiaryGuidelinesUrl,
  personalAccountUrl,
  feesUrl,
};
